import React from 'react';
import { Alert, Button } from 'antd';

/**
 * RestoredFiltersNotice — tells the user the page opened with filters kept
 * from their last visit (see usePersistedFilters) and offers a reset.
 *
 * Props:
 *   - visible:   usually `persisted.wasRestored`
 *   - summary:   optional short text of the active filters
 *   - onReset:   clears the filters
 *   - onDismiss: hides the notice, keeps the filters
 */
var RestoredFiltersNotice = function(props) {
  if (!props.visible) return null;

  return (
    <Alert
      type="info"
      showIcon
      closable
      onClose={props.onDismiss}
      style={{ margin: '8px 0', borderRadius: 8 }}
      message={
        <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>
            Mantivemos os filtros da sua última visita
            {props.summary ? <strong>{': ' + props.summary}</strong> : null}
            .
          </span>
          <Button size="small" onClick={props.onReset}>
            Limpar filtros
          </Button>
        </span>
      }
    />
  );
};

export default RestoredFiltersNotice;
